import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  height: auto;
`;

export const Value = styled.div`
  flex: 1;
  cursor: pointer;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const IconContainer = styled.div`
  position: absolute;
  align-items: flex-end;
  justify-content: center;
  right: 0px;
  top: 35%;
  cursor: pointer;

  padding-right: 10px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #eeeeee;
`;

export const ContainerOptions = styled.div`
  position: absolute;
  background: #ffffff;
  margin-top: 5.2rem;
  box-shadow: rgb(201 201 201 / 50%) 1px 3px 8px 1px;
  z-index: 99;
  width: ${(props) => (props.widthOptions ? props.widthOptions : "100%")};
  border-radius: 0.5rem;
  flex: 1;
  max-height: 250px;
  height: 100%;
  transition: all ease-in 0.6s;
  overflow-y: hidden;
  border: none;

  .option {
    height: 100%;
    overflow-y: scroll;
    cursor: pointer;

    &::-webkit-scrollbar {
      width: 0.5rem;
    }
    &::-webkit-scrollbar-track {
      background: #ddd;
      margin-top: 0;
    }
    &::-webkit-scrollbar-thumb {
      background: #e4003a;
      border: 3px solid #e4003a;
    }
  }
`;

export const Option = styled.button`
  display: flex;
  width: 100%;
  background: #fff;
  color: #444;
  font-size: 16px;

  :hover {
    background: #f1f1f1;
  }
`;

export const ContainerItems = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  padding: 18px 16px;
  max-width: 95%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const OptionLabel = styled.label`
  display: flex;
  justify-content: flex-start;
`;
